/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Can it handle negative fractions?`)
};

const es_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Puede manejar fracciones negativas?`)
};

const de_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kann es negative Brüche verarbeiten?`)
};

const nl_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kan het negatieve breuken verwerken?`)
};

const fr_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Peut-il gérer les fractions négatives ?`)
};

const it_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gestisce le frazioni negative?`)
};

const pt_br2_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ela lida com frações negativas?`)
};

const pt_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Consegue lidar com frações negativas?`)
};

const ja_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`負の分数にも対応していますか?`)
};

const zh_fr_faq_q4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`能处理负分数吗？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const fr_faq_q4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.fr_faq_q4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("fr_faq_q4", locale)
	if (locale === "en") return en_fr_faq_q4(inputs)
	if (locale === "es") return es_fr_faq_q4(inputs)
	if (locale === "de") return de_fr_faq_q4(inputs)
	if (locale === "nl") return nl_fr_faq_q4(inputs)
	if (locale === "fr") return fr_fr_faq_q4(inputs)
	if (locale === "it") return it_fr_faq_q4(inputs)
	if (locale === "pt-BR") return pt_br2_fr_faq_q4(inputs)
	if (locale === "pt") return pt_fr_faq_q4(inputs)
	if (locale === "ja") return ja_fr_faq_q4(inputs)
	return zh_fr_faq_q4(inputs)
};